/* Core & libraries */
import React, { useRef, useState } from "react";
import { FormattedMessage } from "react-intl";

/* Components */
import { ReactComponent as CloseIconSvg } from "../../../../resources/images/close-icon.svg";
import { ReactComponent as CheckIconRed } from "../../../../resources/images/alert-circle.svg";
import Select, { components } from "react-select";
import DynamicImageLoader from "../../../dynamicImageLoader";
import UCOutsideClickHandler from "../../../../components/ucOusideClickHandler/UCOutsideClickHandler.js"; 

/* Styles */
import styles, { selectField, statesSelectError } from "./styles";
import { useTheme } from "react-jss";

const MultiSelectField = ({
  field,
  form,
  value,
  getOptionValue,
  stateGovermenError,
  isOptionSelected,
  options,
  getOptionLabel,
  setStateGovermenError,
  disabled,
  ...props
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const { Option } = components;

  const inputRef = useRef(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const onChange = (selectedOptions) => {
    setStateGovermenError(false);
    form.setFieldValue(field.name, selectedOptions || []);
  };

  const CustomValueContainer = (vcProps) => {
    const { children } = vcProps;

    const childrenArray = React.Children.toArray(children);
    const input = childrenArray[childrenArray.length - 1];
    const multiValues = childrenArray.slice(0, -1);

    return (
      <components.ValueContainer {...vcProps}>
        {multiValues}
        {input}
        <span className={value.states.length > 0 ? classes.inlinePlaceholder : classes.noStates }>
          <FormattedMessage id="fareAccess.stateGoverment.placeholder" />
        </span>
      </components.ValueContainer>
    );
  };

  const SelectedOption = (optionProps) => (
    <Option {...optionProps}>
      {getOptionLabel ? getOptionLabel(optionProps.data) : optionProps.data.label}
      <DynamicImageLoader imageName="select-blue-checkmark.svg" />
    </Option>
  );

  const handleWrapperMouseDown = (e) => {
    if (
      e.target instanceof HTMLElement &&
      e.target.closest("[data-role='chip-remove']")
    ) {
      return;
    }

    e.preventDefault();

    const nextOpen = !menuIsOpen;
    setMenuIsOpen(nextOpen);

    if (nextOpen && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const selectStyles =
    stateGovermenError ? { ...selectField, ...statesSelectError } : selectField;

  const CustomMultiValueRemove = (props) => {
    const { innerProps } = props;

    const handleMouseDown = (e) => {
      e.stopPropagation();

      if (innerProps && innerProps.onMouseDown) {
        innerProps.onMouseDown(e);
      }
    };

    return (
      <components.MultiValueRemove
        {...props}
        innerProps={{
          ...innerProps,
          "data-role": "chip-remove",
          onMouseDown: handleMouseDown,
        }}
        className={classes.closeIconStyle}
      >
        <CloseIconSvg />
      </components.MultiValueRemove>
    );
  };

  return (
    <UCOutsideClickHandler onOutsideClick={() => setMenuIsOpen(false)}>
      <div onMouseDown={handleWrapperMouseDown}>
        <Select
          {...field}
          {...props}
          inputId={field.name}
          name={field.name}
          options={options}
          isMulti
          isDisabled={disabled}
          value={field.value || []}
          onChange={onChange}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          styles={selectStyles}
          menuIsOpen={menuIsOpen}
          inputRef={inputRef}
          openMenuOnClick={false}
          onMenuOpen={() => setMenuIsOpen(true)}
          onMenuClose={() => setMenuIsOpen(false)}
          components={{
            MultiValueRemove: CustomMultiValueRemove,
            Option: SelectedOption,
            ClearIndicator: () => null,
            DropdownIndicator: () =>
              stateGovermenError ? <CheckIconRed /> : null,
            ValueContainer: CustomValueContainer,
            Placeholder: () => null,
            IndicatorSeparator: () => null,
          }}
        />
      </div>
    </UCOutsideClickHandler>
  );
};

export default MultiSelectField;